import React, { useCallback } from 'react';
import ReactDOM from 'react-dom';
import Dialog from '@material-ui/core/Dialog';

export interface AlertProps {
    title?: string;
    message?: string;
    onConfirm?: () => void;
    styles?: any;
}

const alertStyles = {
    modal: {
        width: 600,
    },
    content: {
        padding: '20px',
    },
};

export const Alert: React.FC<AlertProps> = ({ title = 'Alert', message = 'message text not specified', onConfirm, styles = alertStyles }) => {
    const handleConfirm = useCallback(() => {
        onConfirm && onConfirm();
        removeModal();
    }, [onConfirm]);

    return (
        <Dialog
            maxWidth='lg'
            open={true}
            onClose={handleConfirm}
            data-testid='apply-alert-dialog'
            aria-labelledby='form-dialog-title'
        >
            <div className='modal-container'>
                <div className='modal-backdrop'></div>
                <div
                    className='modal'
                    tabIndex={-1}
                    role='dialog'
                    style={styles.modal}
                >
                    <div
                        className='page-header'
                        role='banner'
                    >
                        <h1>{title}</h1>
                    </div>
                    <div
                        className='modal-dialog'
                        role='document'
                        style={styles.content}
                        dangerouslySetInnerHTML={{ __html: message }}
                    ></div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'right',
                            marginRight: 20,
                        }}
                    >
                        <button
                            onClick={handleConfirm}
                            className='button primary'
                            style={{ width: 80, height: 40 }}
                            aria-label='OK'
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

const mountPointId = 'bfi-apply-alert-modal';

// the ignore below are because really the branch being ignored is providing
// arguably over-zealous protection against throwing null-ref exceptions when something
// in the browser has just gone horribly wrong, but really can't be tested
const removeModal = () => {
    const mountPoint = document.getElementById(mountPointId);
    /* istanbul ignore else */
    if (mountPoint) {
        ReactDOM.unmountComponentAtNode(mountPoint);
        mountPoint.parentNode.removeChild(mountPoint);
    }
};

export const alertModal = (props: AlertProps): void => {
    let mountPoint = document.getElementById(mountPointId);
    // istanbul ignore if
    if (mountPoint) {
        ReactDOM.render(<Alert {...props} />, mountPoint);
    } else {
        mountPoint = document.createElement('div');
        mountPoint.id = mountPointId;
        document.body.appendChild(mountPoint);
        ReactDOM.render(<Alert {...props} />, mountPoint);
    }
};
